import { resolveWithBody } from "../Utils/utils";
import { usePromisedRequest } from "../../Common/request";
import { StatusValue } from "../../Common/Competitors/types";

export type CategorySummary = {
    categoryName: string;
    totalCompetitorsForStatuses: Record<StatusValue, number>;
    totalCompetitors: number;
    parameterId: number;
};

export default {
    getCategoriesSummary(eventId: number): Promise<CategorySummary[]> {
        return usePromisedRequest<CategorySummary[]>({
            url: `/api/events/${eventId}/categories-summary`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
};
